import { render, staticRenderFns } from "./ScreenTags.vue?vue&type=template&id=78b16d21&"
import script from "./ScreenTags.vue?vue&type=script&lang=js&"
export * from "./ScreenTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports